<template>
  <v-toolbar class="bottomnav mt-1"  flat dense @click="$emit('clicked')" height="36">
    <v-btn :aria-label="$t('labels.back')" icon >
      <v-icon>$sl-arrow-left</v-icon>
    </v-btn>
    <v-toolbar-title class="body-2">{{$t('labels.previous-step')}}</v-toolbar-title>
  </v-toolbar>
</template>

<script>
export default {
  name:'BottomNav'
};
</script>

<style lang="scss">

</style>